module.exports = __webpack_public_path__ + "img/mtt_5.1.7e1926bd.png";